import { ReactComponent as UICoachLogo } from "../../images/icons/uicoach-logo.svg";
import { ReactComponent as MakerLeagueLogo } from "../../images/makersleague-logo.svg";
import { ReactComponent as NerofitLogo } from "../../images/nerofit-logo.svg";
import { ReactComponent as CopyPageLogo } from "../../images/copypage-logo.svg";
import { ReactComponent as InvisageLogo } from "../../images/icons/invisage-logo.svg";

export const projectTiles = [
  {
    id: "uicoach",
    badgeText: "Live",
    badgeClass: "cp-tile-badge--live",
    title: "UI Coach",
    Logo: UICoachLogo,
    logoClassName: "mb-2 h-12 w-12",
  },
  {
    id: "invisage",
    badgeText: "Live",
    badgeClass: "cp-tile-badge--live",
    title: "Invisage",
    Logo: InvisageLogo,
    logoClassName: "mb-2 h-12 w-12",
  },
  {
    id: "makersLeague",
    badgeText: "Inactive",
    badgeClass: "cp-tile-badge--inactive",
    title: "Makers League",
    Logo: MakerLeagueLogo,
    logoClassName: "mb-2 h-12 w-12",
  },
  {
    id: "copyPage",
    badgeText: "Inactive",
    badgeClass: "cp-tile-badge--inactive",
    title: "Copy Page",
    Logo: CopyPageLogo,
    logoClassName: "mb-2 h-12 w-12",
  },
  {
    id: "nerofit",
    badgeText: "Inactive",
    badgeClass: "cp-tile-badge--inactive",
    title: "Nero-Fit Apparel",
    Logo: NerofitLogo,
    logoClassName: "mb-2 h-14 w-14",
  },
];
